import { getFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-18379 Блокирующий экран для удаленных оверквотеров
export const overquotaAfterClear: boolean = getFeature('overquota-after-clear') ?? false;
